import React, { useState } from 'react';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Skeleton } from '@material-ui/lab';
import parse from 'html-react-parser';

const useStyles = makeStyles({
  table: {
    width: '100%',
    border: 'none',
    marginBottom: 16,

    '& tr, & th, & td': {
      border: 'none',
    },

    '& th': {
      color: '#fff',
    },

    '& td': {
      minWidth: 70,
      padding: '4px 0',
      textAlign: 'center',
      verticalAlign: 'middle',
      '@media screen and (max-width: 950px)': {
        fontSize: 14,
      },
      '@media screen and (max-width: 650px)': {
        fontSize: 12,
      },
    },

    '& th h5': {
      '@media screen and (max-width: 950px)': {
        fontSize: 16,
      },
      '@media screen and (max-width: 650px)': {
        fontSize: 14,
      },
    },
  },
  tableHead: {
    backgroundColor: '#e3232a',
  },
  trWithBorder: {
    borderTop: '2px solid black',
  },
  textHeadTable: {
    fontWeight: 200,
    marginBottom: 8,
  },
  wrapTahap: {
    maxWidth: 1200,
    margin: '0 auto',
    padding: '0 16px',
    paddingBottom: '5rem',
    '@media screen and (max-width: 600px)': {
      padding: 0,
    },
  },
});

const InformasiTol = ({ isId }: any) => {
  const classes = useStyles();
  const [loadingState, setLoadingState] = useState(true);
  const [dataTarifState, setDataTarifState] = useState<any>(null);
  const [informasiTolState, setInformasiTolState] = useState<any>(null);

  const getDataTarif = async () => {
    const res: any = await fetch(
      `${process.env.REACT_APP_URL}/api/jlp/beranda/tbl-tarif`
    );
    const resJson = await res.json();
    const formatDataTarif: any = resJson.data.rows.reduce(
      (acc: any, d: any) => {
        const found = acc.find(
          (a: any) => a.asal === d.asal && a.tujuan === d.tujuan
        );
        const value = {
          golongan: d.golongan,
          tarif: d.tarif,
        };
        if (!found) {
          acc.push({
            tahap: d.tahap,
            asal: d.asal,
            tujuan: d.tujuan,
            data: [value],
          });
        } else {
          found.data.push(value);
        }
        return acc;
      },
      []
    );
    setDataTarifState(formatDataTarif);
  };

  const getDataInformasiTol = async () => {
    const res = await fetch(
      `${process.env.REACT_APP_URL}/api/jlp/content?type=15`
    );
    const resJson = await res.json();
    setInformasiTolState(
      resJson.data.rows.sort(
        (a: any, b: any) => parseFloat(a.id) - parseFloat(b.id)
      )
    );
  };

  const firstLoad = async () => {
    try {
      await getDataTarif();
      await getDataInformasiTol();
      setLoadingState(false);
    } catch (err: any) {
      console.log(err.message);
    }
  };

  React.useEffect(() => {
    firstLoad();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div
        style={{
          maxWidth: 1280,
          margin: '0 auto',
          padding: '0 16px',
        }}
      >
        <Typography style={{ marginBottom: '4rem' }}>
          {isId ? 'Jalan Tol Kami' : 'Our Toll Road'}
          &nbsp; &gt; &nbsp;{' '}
          <span style={{ color: '#e3232a' }}>
            {isId ? 'Informasi Tol' : 'Toll Information'}
          </span>
        </Typography>
        <Typography
          color='primary'
          variant='h4'
          style={{ marginBottom: '2rem' }}
        >
          {isId ? 'Peta Jalan Tol' : 'Toll Road Maps'}
        </Typography>
        <div className={classes.wrapTahap}>
          {loadingState ? (
            <>
              <Skeleton
                variant='rect'
                style={{ maxWidth: 300, height: 30, marginBottom: 16 }}
              />
              <Skeleton variant='rect' style={{ width: '100%', height: 400 }} />
            </>
          ) : (
            informasiTolState.map((row: any) => (
              <div key={row.id} style={{ marginBottom: 32 }}>
                <Typography style={{ fontWeight: 700, marginBottom: 16 }}>
                  {isId ? row.title_id : row.title_en}
                </Typography>
                <img
                  src={`${process.env.REACT_APP_URL}/images/${row.image}`}
                  alt='img our toll road'
                  style={{
                    width: '100%',
                    marginBottom: 16,
                  }}
                />
                <div id='content'>
                  {parse(isId ? row.content_id : row.content_en)}
                </div>
              </div>
            ))
          )}
        </div>
      </div>
      <div
        style={{
          backgroundColor: '#f0f0f0',
        }}
      >
        <div
          style={{
            maxWidth: 1280,
            margin: '0 auto',
            padding: '2rem 16px',
            paddingBottom: '4rem',
          }}
        >
          <Typography
            color='primary'
            variant='h4'
            style={{ marginBottom: '2rem' }}
          >
            {isId ? 'Tarif Tol' : 'Toll Rates'}
          </Typography>
          <div className={classes.wrapTahap} style={{ paddingBottom: 0 }}>
            {loadingState ? (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <Skeleton
                  variant='rect'
                  style={{
                    width: '100%',
                    maxWidth: 350,
                    height: 40,
                    marginBottom: 16,
                  }}
                />
                <Skeleton
                  variant='rect'
                  style={{
                    width: '100%',
                    maxWidth: 200,
                    height: 20,
                    marginBottom: 16,
                  }}
                />
                <Skeleton
                  variant='rect'
                  style={{ width: '100%', height: 210, marginBottom: 16 }}
                />
              </div>
            ) : (
              informasiTolState.map((row: any) => (
                <div key={row.id} style={{ marginBottom: 64 }}>
                  <Typography color='primary' variant='h5' align='center'>
                    {isId ? row.sub_title_id : row.sub_title_en}
                  </Typography>
                  <Typography
                    align='center'
                    style={{ fontWeight: 700, marginBottom: '2rem' }}
                  >
                    {isId ? row.second_sub_title_id : row.second_sub_title_en}
                  </Typography>
                  <div style={{ overflowX: 'scroll' }}>
                    <table
                      className={classes.table}
                      cellSpacing='0'
                      cellPadding='0'
                    >
                      <tr className={classes.tableHead}>
                        <th rowSpan={2}>
                          <Typography
                            variant='h5'
                            className={classes.textHeadTable}
                          >
                            Asal Perjalanan
                          </Typography>
                        </th>
                        <th rowSpan={2}>
                          <Typography
                            variant='h5'
                            className={classes.textHeadTable}
                          >
                            Tujuan Perjalanan
                          </Typography>
                        </th>
                        <th colSpan={5} style={{ paddingTop: 12 }}>
                          <Typography
                            variant='h5'
                            className={classes.textHeadTable}
                          >
                            Besarnya Tarif Tol
                          </Typography>
                        </th>
                      </tr>
                      <tr className={classes.tableHead}>
                        <th>
                          <Typography
                            variant='h5'
                            className={classes.textHeadTable}
                          >
                            Gol I
                          </Typography>
                        </th>
                        <th>
                          <Typography
                            variant='h5'
                            className={classes.textHeadTable}
                          >
                            Gol II
                          </Typography>
                        </th>
                        <th>
                          <Typography
                            variant='h5'
                            className={classes.textHeadTable}
                          >
                            Gol III
                          </Typography>
                        </th>
                        <th>
                          <Typography
                            variant='h5'
                            className={classes.textHeadTable}
                          >
                            Gol IV
                          </Typography>
                        </th>
                        <th>
                          <Typography
                            variant='h5'
                            className={classes.textHeadTable}
                          >
                            Gol V
                          </Typography>
                        </th>
                      </tr>
                      <tr>
                        <td colSpan={7}>
                          <div className={classes.trWithBorder} />
                        </td>
                      </tr>
                      {dataTarifState
                        ?.filter(
                          (filterTarif: any) => filterTarif.tahap === +row.place
                        )
                        .map((rowTarif: any, i: number) => (
                          <tr
                            key={rowTarif.asal}
                            style={{
                              backgroundColor: i % 2 === 0 ? '#fff' : '#e4e4e4',
                            }}
                          >
                            <td>{rowTarif.asal}</td>
                            <td>{rowTarif.tujuan}</td>
                            {rowTarif.data.map((dataGol: any) => (
                              <td key={dataGol.golongan}>
                                {rowTarif.asal === 'KELAPA GADING' &&
                                rowTarif.tujuan === 'CAKUNG'
                                  ? '*'
                                  : null}
                                {Intl.NumberFormat('id-Id').format(
                                  dataGol.tarif
                                )}
                              </td>
                            ))}
                          </tr>
                        ))}
                    </table>
                  </div>
                  <div id='content'>
                    {parse(isId ? row.sub_content_id : row.sub_content_en)}
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default InformasiTol;
